import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import { useFormContext } from "react-hook-form";
import { META } from "../../../utils/constants";
import Button from "../../../components/Buttons/Button";
import ModalSavedAudiencesMeta from "../../../components/Platforms/Meta/Common/ModalSavedAudiencesMeta";
import {
  BUTTON_USE_SAVED_AUDIENCE,
  MODAL_SAVED_AUDIENCES_DESCRIPTION,
} from "../../../i18n/keysTranslations";

const AdsGroupFormChooseSavedAudience = ({ BASIC_PATH, disabled = false }) => {
  const [modalOpenSavedAudience, setModalOpenSavedAudience] = useState(false);
  const { t } = useTranslationApp();

  const { getValues, setValue } = useFormContext();

  const platformData = getValues(`platformsData.${META}`) || {};

  const onCallbackSave = (savedAudience = {}) => {
    const targeting = savedAudience.targeting || {};
    Object.keys(targeting).forEach((key) => {
      setValue(`${BASIC_PATH}.${key}`, targeting[key]);
    });
    setModalOpenSavedAudience(false);
  };
  return (
    <Box
      id={name}
      sx={{
        mb: 1,
      }}
    >
      <Typography
        variant="body1"
        sx={{
          mb: 2,
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "#00000",
          "& .MuiSvgIcon-root": {
            fontSize: "1.25rem",
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        {t(MODAL_SAVED_AUDIENCES_DESCRIPTION)}
      </Typography>
      {!disabled && (
        <Box sx={{ mt: 2, width: "100%" }}>
          <Button
            color="secondary"
            type="button"
            onClick={() => setModalOpenSavedAudience(true)}
            sx={{
              width: "100%",
            }}
          >
            {t(BUTTON_USE_SAVED_AUDIENCE)}
          </Button>
        </Box>
      )}
      {modalOpenSavedAudience && (
        <ModalSavedAudiencesMeta
          modalOpen={modalOpenSavedAudience}
          onCloseModal={() => setModalOpenSavedAudience(false)}
          adAccountID={platformData.adAccountID}
          integrationID={platformData.integrationID}
          onCallbackSave={onCallbackSave}
        />
      )}
    </Box>
  );
};

export default AdsGroupFormChooseSavedAudience;
